// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withLocalization from "../hocs/withLocalization";
import { graphql } from "react-apollo";
import entryScreenQuery from "../queries/entryScreen";
import withErrorState from "../hocs/withErrorState";
import withFlattenedTranslations from "../hocs/withFlattenedTranslations";
import { withStyles } from "@material-ui/core/styles";
import { sharedStyles } from "./EntryScreenMenu";
import withLoadingState from "../hocs/withLoadingState";
import HeaderMenuItem from "./HeaderMenuItem";

const styles = (theme) => ({
    ...sharedStyles(),
    root: {
        display: "flex",
    },
    item: {
        marginRight: "1.5rem",
    },
});

const HeaderMenu = ({ entryScreenItems, classes }) => {
    return (
        <div className={classes.root}>
            {entryScreenItems.map((item) => (
                <div key={item.id} className={classes.item}>
                    <HeaderMenuItem entryScreenItem={item} />
                </div>
            ))}
        </div>
    );
};

export default compose(
    withConnectionStatus,
    withLocalization,
    graphql(entryScreenQuery, {
        options: ({ language, fetchPolicy, stage }) => ({
            variables: {
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withErrorState,
    withLoadingState("vehicle", "text"),
    withFlattenedTranslations("entryScreenItems"),
    withStyles(styles)
)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js